import React from 'react';
import SimpleBar from 'simplebar-react';
import { default as bemCssModules } from 'bem-css-modules';
import { Shade } from '../Shade/Shade';
import { useStore } from '../../store/AppStore';
import { default as ShadesStyles } from './Shades.module.css';
const style = bemCssModules(ShadesStyles);
export const Shades = () => {
    const { shades, activeShade } = useStore();
    return (React.createElement("div", { className: style() },
        React.createElement("ul", { className: style('active-shade') },
            React.createElement("li", { className: style('shade-detail') }, activeShade === null || activeShade === void 0 ? void 0 : activeShade.name),
            React.createElement("li", { className: style('shade-detail') }, activeShade === null || activeShade === void 0 ? void 0 : activeShade.code)),
        React.createElement(SimpleBar, null,
            React.createElement("div", { className: style('wrapper') }, shades.map((shade) => React.createElement(Shade, Object.assign({ key: shade.code }, shade)))))));
};
